import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

// eslint-disable-next-line @nx/enforce-module-boundaries
import packageJson from '../../../../../../package.json';
import {
  HealthCheckRepository,
  Version
} from '../repositories/health-check.repository';
import { ModalService } from '@bling-fe/shared/modals/base-modal';
import { UpdateInfoModalComponent } from '../../modals/update-info-modal/update-info-modal.component';
import { compare } from 'compare-versions';

@Injectable({
  providedIn: 'root'
})
export class HealthCheckService {
  endpointVersion: string;
  appVersion = packageJson.version;
  private message: BehaviorSubject<string> = new BehaviorSubject(
    this.translate.instant('APP_VERSION.UPDATE')
  );

  constructor(
    private translate: TranslateService,
    private healthCheckRepo: HealthCheckRepository,
    private modalService: ModalService
  ) {}

  async checkVersion() {
    this.healthCheckRepo.getVersion().subscribe((data: Version) => {
      this.endpointVersion = data.version;
      this.translate.stream('APP_VERSION.UPDATE').subscribe(translation => {
        this.message.next(translation);
      });
      if (this.isUpdateSuggested()) {
        this.showUpdateModal();
      }
    });
  }

  isUpdateSuggested() {
    if (!Capacitor.isNativePlatform()) {
      return false;
    }
    if (!this.endpointVersion || !this.appVersion) {
      return false;
    }
    return compare(this.endpointVersion, this.appVersion, '>');
  }

  private async showUpdateModal() {
    await this.modalService.presentAndGetResult(UpdateInfoModalComponent, {
      message: this.message
    });
  }
}
